import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LOGO_URL = "/images/logo/logo.webp";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-accent-950 text-background-100 pt-14 md:pt-20 pb-6">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img src={LOGO_URL} alt="Mateo Teneryfa" className="h-10 w-auto rounded-md object-contain" />
              <div className="flex flex-col leading-tight">
                <span className="font-heading text-lg font-semibold text-background-50">Mateo Teneryfa</span>
                <span className="text-[10px] uppercase tracking-[0.18em] text-background-300">wycieczki</span>
              </div>
            </div>
            <p className="text-sm text-background-200 leading-relaxed">
              {t("ft_tagline")}
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm uppercase tracking-wider flex items-center gap-2">
              <span className="w-1 h-4 rounded-full bg-accent-400 inline-block"></span>
              {t("ft_contact")}
            </h4>
            <ul className="space-y-3 text-sm text-background-200">
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center text-accent-400"><i className="ri-time-line"></i></div>
                <span>{t("ft_hours")}</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center text-accent-400"><i className="ri-mail-line"></i></div>
                <a href="mailto:kontakt@mateoteneryfa.pl" className="hover:text-accent-300 cursor-pointer">kontakt@mateoteneryfa.pl</a>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center text-accent-400"><i className="ri-whatsapp-line"></i></div>
                <a href="https://wa.me/48792842613" target="_blank" rel="noopener noreferrer" className="hover:text-accent-300 cursor-pointer">
                  {t("ft_whatsapp_number")}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center text-primary-400"><i className="ri-phone-line"></i></div>
                <div className="flex flex-col gap-0.5">
                  <a href="tel:+34604150904" className="hover:text-accent-300 cursor-pointer">+34 604 150 904</a>
                  <span className="text-xs text-background-400">{t("ft_phone_local_label")}</span>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center text-accent-400"><i className="ri-map-pin-line"></i></div>
                <span>{t("ft_location")}</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm uppercase tracking-wider flex items-center gap-2">
              <span className="w-1 h-4 rounded-full bg-primary-400 inline-block"></span>
              {t("ft_explore")}
            </h4>
            <ul className="space-y-3 text-sm text-background-200">
              <li><Link to="/" className="hover:text-accent-300 cursor-pointer">{t("nav_home")}</Link></li>
              <li><Link to="/excursion/buggy-volcano" className="hover:text-accent-300 cursor-pointer">{t("ft_buggy")}</Link></li>
              <li><Link to="/excursion/jungle-park" className="hover:text-accent-300 cursor-pointer">{t("ft_jungle")}</Link></li>
              <li><Link to="/excursion/twin-ticket" className="hover:text-accent-300 cursor-pointer">{t("ft_twin")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm uppercase tracking-wider flex items-center gap-2">
              <span className="w-1 h-4 rounded-full bg-accent-400 inline-block"></span>
              {t("ft_social")}
            </h4>
            <p className="text-sm text-background-200 mb-4 leading-relaxed">
              {t("ft_social_text")}
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/share/18s1Yq8cTT/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-background-50/10 hover:bg-accent-600 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-background-50"></i>
              </a>
              <a
                href="https://www.instagram.com/mateo_teneryfa?igsh=MWIyd3EyOWhlMmp6Yw=="
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-background-50/10 hover:bg-accent-500 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-background-50"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <span>{t("ft_copyright")}</span>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-accent-300 cursor-pointer">{t("ft_privacy")}</a>
            <a href="#" className="hover:text-accent-300 cursor-pointer">{t("ft_cookies")}</a>
            <a href="#" className="hover:text-accent-300 cursor-pointer">{t("ft_terms")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}